import React from 'react'

type Props = {
  format?: string | null
  category?: string | null
  className?: string
  labelOverride?: string | null
}

function normalizeFormat(format?: string | null): 'micro' | 'zine' | 'event' | null {
  const value = String(format || '').toLowerCase()
  if (!value) return 'zine'
  if (value === 'micro') return 'micro'
  if (value === 'zine') return 'zine'
  if (value === 'event') return 'event'
  return null
}

function formatLabel(format?: string | null): string | null {
  const normalized = normalizeFormat(format)
  if (normalized === 'micro') return 'MICRO'
  if (normalized === 'zine') return 'ZINE'
  if (normalized === 'event') return 'EVENT'
  return null
}

export default function FormatWatermark({ format, category, className = '', labelOverride }: Props) {
  const label = String(labelOverride || '').trim().toUpperCase() || formatLabel(format)
  if (!label) return null

  const categoryLabel = String(category || '').trim().toUpperCase()

  return (
    <div className={`text-[11px] font-semibold tracking-[0.2em] uppercase text-white/70 drop-shadow-[0_2px_8px_rgba(0,0,0,0.35)] ${className}`.trim()}>
      <div>
        PIXE <span className="text-white/55">{'\u2022'}</span> {label}
      </div>
      {categoryLabel ? <div className="mt-1 text-[10px] font-medium tracking-[0.16em] text-white/55">{categoryLabel}</div> : null}
    </div>
  )
}
